import { Observable, of } from "rxjs";

import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { environment } from "../../environments/environment";
import { AuthServiceService } from "./auth-service.service";
import { TokenRequestModel } from "../Models/tokenRequestModel.model";

@Injectable({
  providedIn: "root",
})
export class AzureAuthService {
  public azurenoUser: boolean;
  private user = null;

  constructor(
    protected http: HttpClient,
    public authService: AuthServiceService
  ) {
    const adalConfig = environment.analystsAdalConfig;
    adalConfig["callback"] = this.callbackFunction;
  }

  public isLoggedIn(): boolean {
    return true;
  }

  public callbackFunction() {
    this.sampleFunction();
  }

  public sampleFunction() {
  }
  public signout(): void {
    localStorage.removeItem('UserGraphToken');
  }

  public startAuthentication(): any {
  }

  public getName(): string {
    return this.user.profile.name;
  }
}
